// components/Lvl3Landing.tsx - Clean Minimalistic Version
import React from 'react';
import { useMotionPreferences } from '../hooks/useMotionPreferences';
// import { useTypewriter } from '../hooks/useTypewriter';
// import { CTAButtons } from './CTAButtons';

interface Lvl3LandingProps {
  className?: string;
  onChatClick?: () => void;
  onAccessClick?: () => void;
}

const Lvl3Landing: React.FC<Lvl3LandingProps> = ({
  className = '',
  onChatClick,
  // onAccessClick
}) => {
  const { isLoaded } = useMotionPreferences(100);
  // const FULL_TEXT = "Purpose Understood.";
  // const { displayText, isComplete } = useTypewriter(FULL_TEXT, 80, prefersReducedMotion, 500);
  const [chatInput, setChatInput] = React.useState('');
  return (
    <div className={`min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-purple-900 text-white flex flex-col items-center justify-start px-4 pt-16 ${className}`}>
      
      {/* Content Container - Limited to top 50% */}
      <div className="w-full max-w-6xl flex flex-col items-center min-h-[50vh] justify-center">
        
        {/* Logo */}
        <div className={`mb-24 transition-all duration-700 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
          <h1 className="text-6xl md:text-8xl font-thin tracking-tighter text-center">
            <span className="text-white">LVL</span>
            <span className="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">3</span>
            <span className="text-white">.AI</span>
          </h1>
        </div>

        {/* Main Message - COMMENTED OUT */}
        {/* <div className={`text-center transition-all duration-700 delay-200 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
          <h2 className="text-3xl md:text-5xl font-light mb-4">
            Intelligence beyond limits
          </h2>
          <p className="text-lg text-white/80 mb-6">
            Deploy autonomous AI agents that scale your business infinitely.
          </p>
        </div> */}

        {/* Large Chat Interface - Lovable Style */}
        <div className={`w-full max-w-4xl transition-all duration-700 delay-400 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
          <div className="backdrop-blur-md bg-white/10 rounded-3xl p-8 border border-white/20 shadow-2xl">
            <div className="mb-4">
              <input 
                type="text" 
                placeholder="Purpose Understood"
                className="w-full bg-transparent text-white placeholder-white/60 border-none outline-none text-xl py-4 font-light"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
              />
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-6">
                <button className="text-white/60 hover:text-white transition-colors text-2xl">
                  +
                </button>
                <button className="text-white/60 hover:text-white transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" clipRule="evenodd" />
                  </svg>
                </button>
                <button className="text-white/60 hover:text-white transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
              <div className="flex items-center gap-4">
                <span className="text-white/60 text-base">Public</span>
                <button 
                  className="w-14 h-14 bg-slate-800/50 hover:bg-slate-700/50 rounded-full flex items-center justify-center transition-colors border border-white/10"
                  onClick={onChatClick}
                >
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Buttons - COMMENTED OUT */}
        {/* <div className={`transition-all duration-700 delay-600 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
          <CTAButtons
            onChatClick={onChatClick}
            onAccessClick={onAccessClick}
            isLoaded={isLoaded}
            prefersReducedMotion={prefersReducedMotion}
          />
        </div> */}

        {/* Typewriter Status - COMMENTED OUT */}
        {/* <div className={`transition-all duration-700 delay-800 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
          <div className="backdrop-blur-sm bg-white/5 rounded-xl px-6 py-3 border border-white/10">
            <p className="text-lg text-white/90 text-center">
              {displayText}
              {!isComplete && <span className="opacity-70">|</span>}
            </p>
          </div>
        </div> */}

      </div>
    </div>
  );
};

export default Lvl3Landing;